enum Permission {
  AccessAllowed,
  FeedbackSubmissionAllowed,
  OpenClaimInFSCAllowed
}

export default Permission;
